import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useContext, useMemo, useRef, useState } from 'react';
import { AnalyticsListener } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../constants';
var UNKNOWN = 'unknown';
var DEFAULT_CONTEXT_ATTRIBUTES = {
  triggeredFrom: UNKNOWN,
  objectName: UNKNOWN,
  appearance: 'modal'
};
var LinkCreateAnalyticsContext = /*#__PURE__*/React.createContext({
  trackAttribute: function trackAttribute() {},
  trackAttributes: function trackAttributes() {},
  getAttributes: function getAttributes() {
    return DEFAULT_CONTEXT_ATTRIBUTES;
  }
});
var LinkCreateAnalytics = function LinkCreateAnalytics(_ref) {
  var initialContext = _ref.initialContext,
    children = _ref.children;
  var dataRef = useRef(_objectSpread(_objectSpread({}, DEFAULT_CONTEXT_ATTRIBUTES), initialContext));
  var methods = useMemo(function () {
    return {
      trackAttribute: function trackAttribute(key, value) {
        dataRef.current[key] = value;
      },
      trackAttributes: function trackAttributes(attributes) {
        dataRef.current = _objectSpread(_objectSpread({}, dataRef.current), attributes);
      },
      getAttributes: function getAttributes() {
        return dataRef.current;
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(LinkCreateAnalyticsContext.Provider, {
    value: methods
  }, children);
};
var contextAttributesFromInitialProps = function contextAttributesFromInitialProps(props) {
  return {
    objectName: props.entityKey,
    triggeredFrom: props.triggeredFrom
  };
};

/**
 * Hook that exposes the context-level attribute getters and setters.
 */
export var useLinkCreateAnalytics = function useLinkCreateAnalytics() {
  return useContext(LinkCreateAnalyticsContext);
};

/**
 * Wrap component in "attributes" context store and initialise the initial context attributes from props.
 */
function withLinkCreateAnalytics(WrappedComponent) {
  return function (props) {
    var _useState = useState(function () {
        return contextAttributesFromInitialProps(props);
      }),
      _useState2 = _slicedToArray(_useState, 1),
      initialContext = _useState2[0];
    return /*#__PURE__*/React.createElement(LinkCreateAnalytics, {
      initialContext: initialContext
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
}

/**
 * Wraps a component with the analytics context + listener to update events with contextual-level attributes.
 * Should be implemented once at the root of the link create.
 */
export function withLinkCreateAnalyticsContext(WrappedComponent) {
  return withLinkCreateAnalytics(function (props) {
    var _useLinkCreateAnalyti = useLinkCreateAnalytics(),
      getAttributes = _useLinkCreateAnalyti.getAttributes;
    var onEvent = useCallback(function (event) {
      var _event$payload$attrib;
      event.update({
        attributes: _objectSpread(_objectSpread({}, getAttributes()), (_event$payload$attrib = event.payload.attributes) !== null && _event$payload$attrib !== void 0 ? _event$payload$attrib : {})
      });
    }, [getAttributes]);
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      channel: ANALYTICS_CHANNEL,
      onEvent: onEvent
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  });
}